import React from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import PropTypes from 'prop-types';

/**
 * The library's download, without its button: the manual-orders export table is built only when Excel is
 * clicked, so the download is started from code (ref.current.handleDownload()) once the table exists.
 */
const ExcelDownloader = React.forwardRef(({ table, filename }, ref) => (
    <div style={{ display: 'none' }} aria-hidden="true">
        <ReactHTMLTableToExcel ref={ref} table={table} filename={filename} sheet="ד''וח" buttonText="" />
    </div>
));

ExcelDownloader.propTypes = {
    table: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
};

export default ExcelDownloader;
